import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决ElementUI导航栏中重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)

}
export default new VueRouter({
  routes: [{
      path: '/',
      name: 'Index',
      component: () => import('@/views/Index/index'),
      children: [{
        path: '/',
        component: () => import('@/views/Index/index_Statistic'),
        name: 'index_Statistic',
        meta: {
          title: '首页',
          noCache: true,
          affix: true,
          keepAlive: false,
        }
      }, {
        path: '/home',
        component: () => import('@/views/Index/home'),
        name: 'home',
        meta: {
          title: '订单管理',
          noCache: true,
          affix: true,
          keepAlive: false,
        }
      }, {
        path: '/Data_import',
        component: () => import('@/views/Index/Data_import'),
        name: 'Data_import',
        meta: {
          title: '数据导入',
          noCache: true,
          affix: true,
          keepAlive: false,
        }
      }, {
        path: '/New_shipping_Zx',
        component: () => import('@/views/Index/New_shipping_Zx'),
        name: 'New_shipping_Zx',
        meta: {
          title: '海运-整柜送仓',
          noCache: true,
          affix: true,
          keepAlive: false,
        }
      }, {
        path: '/New_shipping_Px',
        component: () => import('@/views/Index/New_shipping_Px'),
        name: 'New_shipping_Px',
        meta: {
          title: '海运-整柜拼箱入仓拆派',
          noCache: true,
          affix: true,
          keepAlive: false,
        }
      }, {
        path: '/New_airlift_Zx',
        component: () => import('@/views/Index/New_airlift_Zx'),
        name: 'New_airlift_Zx',
        meta: {
          title: '空运-整票',
          noCache: true,
          affix: true,
          keepAlive: false,
        }
      }, {
        path: '/New_airlift_Px',
        component: () => import('@/views/Index/New_airlift_Px'),
        name: 'New_airlift_Px',
        meta: {
          title: '空运-整票入仓拆派',
          noCache: true,
          affix: true,
          keepAlive: false,
        }
      }, {
        path: '/Problem_piece',
        component: () => import('@/views/Index/Problem_piece'),
        name: 'Problem_piece',
        meta: {
          title: '问题件管理',
          noCache: true,
          affix: true,
          keepAlive: false,
        }
      }, {
        path: '/Financial_Center',
        component: () => import('@/views/Index/Financial_Center'),
        name: 'Financial_Center',
        meta: {
          title: '财务中心',
          noCache: true,
          affix: true,
          keepAlive: false,
        }
      }, {
        path: '/Bill_details',
        component: () => import('@/views/Index/Bill_details'),
        name: 'Bill_details',
        meta: {
          title: '账单明细',
          noCache: true,
          affix: true,
          keepAlive: false,
        }
      }, {
        path: '/payment_document',
        component: () => import('@/views/Index/payment_document'),
        name: 'payment_document',
        meta: {
          title: '上传支付凭证',
          noCache: true,
          affix: true,
          keepAlive: false,
        }
      }, {
        path: '/order_detail',
        component: () => import('@/views/Index/order_detail'),
        name: 'order_detail',
        meta: {
          title: '运单详情',
          noCache: true,
          affix: true,
          keepAlive: false,
        }
      }]
    }, {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Index/login'),
    },
    {
      path: '/GoogleMap',
      name: 'GoogleMap',
      component: () => import('@/views/Index/GoogleMap'),
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js